(function () {
  "use strict";
  var source = document.currentScript;
  var addUrl = source.dataset.addUrl;
  var cartUrl = source.dataset.cartUrl;
  var pending = false;
  document.addEventListener("click", function (event) {
    var link = event.target.closest("a[href]");
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    var path = new URL(link.href, location.origin);
    if (path.origin !== location.origin) return;
    var match = path.pathname.match(/\/cart\/(44069005688895|44069005721663|44069005754431):1\/?$/);
    if (!match) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    var form = document.createElement("form");
    form.method = "post";
    form.action = addUrl;
    form.hidden = true;
    Object.entries({id: match[1], quantity: "1", return_to: cartUrl}).forEach(function (entry) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = entry[0];
      input.value = entry[1];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  });
  window.addEventListener("pageshow", function () { pending = false; });
})();
